import setPathToObject, { splitNotPrecededBy } from '@lib/utils/setPathToObject';
import { FixMe } from '@utils/types';
import { cloneDeep } from 'lodash';
import { important_overrides } from '../tableMappingProvider';

// transform any object key with dot in path into an object e
// example: {test.value[0].id:1} = { test: { value: [{id:1}] } }
const transformSupportArray = (json: { [i: string]: FixMe }) =>
  Object.keys(json).reduce((accum: FixMe, key) => {
    const value = json[key];
    if (/\[\d]/.test(key)) {
      const [firstKey, secondKey] = key.split(/\[\d]/);
      const arrayObjectKey = secondKey.replace('.', '');
      const match = key.match(/\[(\d)]/) || [];
      const index = Number(match[1]);
      const currentAccumValue = accum[firstKey];
      if (currentAccumValue && Array.isArray(currentAccumValue)) {
        accum[firstKey] = currentAccumValue;
        // eslint-disable-next-line no-multi-assign
        accum[firstKey][index] = currentAccumValue[index] = {
          ...currentAccumValue[index],
          [arrayObjectKey]: value,
        };
      } else {
        const temp = [];
        temp[index] = { [arrayObjectKey]: value };
        accum[firstKey] = [...temp];
      }
      accum[firstKey] = Array.from(accum[firstKey], (val) => (!val ? {} : val));
    } else {
      accum[key] = value;
    }
    return accum;
  }, {});

// transform any object key with dot in path into an object e
// example: {test.value:1} = { test: { value: 1 } }
const transformJSONSupportPath = (json: FixMe) => {
  if (typeof json !== 'object' || Array.isArray(json)) {
    return json;
  }
  return Object.keys(json).reduce((accum: FixMe, key) => {
    let value = json[key];
    if (Array.isArray(value)) {
      value = value.map(transformJSONSupportPath);
    } else if (value && typeof value === 'object') {
      value = transformJSONSupportPath(transformSupportArray(value));
    }
    if (/[^.\\]\./.test(key)) {
      const [firstKey] = splitNotPrecededBy(key, '\\.', '\\\\');
      // need to make object that includes {value:{...}}
      const path = key.replace(`${firstKey}.`, '');
      const currentAccumValue = accum[firstKey.replace(/\\/g, '')];
      accum[firstKey.replace(/\\/g, '')] = setPathToObject(
        currentAccumValue ? { ...currentAccumValue } : {},
        path,
        value,
      );
    } else {
      accum[key.replace(/\\/g, '')] = value;
    }
    return accum;
  }, {});
};

const exportObjectsFromTraits = (json: { [i: string]: FixMe; traits: FixMe }) => {
  if (!json.traits) {
    return json;
  }
  const cleanObject = Object.keys(json.traits).reduce(
    (accum, key) => {
      const currentValue = json.traits[key];
      if (/[^.\\]\./.test(key) && !/^traits\./.test(key)) {
        accum[key] = currentValue;
      } else {
        accum.traits[key.replace(/traits\./g, '')] = currentValue;
      }
      return accum;
    },
    {
      traits: {} as FixMe,
    } as FixMe,
  );
  const { traits, ...restJson } = json;
  const { traits: tr, ...restClean } = cleanObject;
  return {
    ...restJson,
    ...restClean,
    traits: tr || traits,
  };
};

const transform = (
  jsonData: { [i: string]: FixMe },
  constants: string[],
  recursive?: boolean,
  renames: { [i: string]: FixMe } = {},
) => {
  const json = cloneDeep(jsonData);
  const jsonObject = Object.keys(json).reduce(
    (accum: FixMe, originalColumnName) => {
      const value = json[originalColumnName];
      const validKey = constants.includes(originalColumnName)
        ? originalColumnName
        : originalColumnName.replace(/\./g, '\\.');
      let newNameArr = renames[validKey];
      if (important_overrides.map((col) => `${col}_dup`).includes(validKey.toLowerCase())) {
        newNameArr = renames[validKey.replace('_dup', '')] || [];
      } else if (important_overrides.includes(validKey.toLowerCase()) || !newNameArr) {
        newNameArr = [validKey];
      }
      if (
        newNameArr &&
        !Array.isArray(newNameArr) &&
        typeof newNameArr === 'object' &&
        value &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        const tranformeddObj = transform(value, constants, true, newNameArr);
        accum.values[validKey] = tranformeddObj.values;
        accum.renames[validKey.replace(/\[\d]/, '')] = tranformeddObj.renames;
      } else {
        ((newNameArr as string[]) || []).forEach((name) => {
          accum.values[name] =
            value && typeof value === 'object' && !Array.isArray(value)
              ? transform(value, constants, true, {}).values
              : value;
          accum.renames[name.replace(/\[\d]/, '')] =
            name.toLowerCase() !== originalColumnName.toLowerCase();
        });
      }
      return accum;
    },

    { values: {}, renames: {} },
  );

  if (recursive) {
    return jsonObject;
  }
  return {
    renames: transformJSONSupportPath(exportObjectsFromTraits(jsonObject.renames)),
    values: transformJSONSupportPath(
      transformSupportArray(exportObjectsFromTraits(jsonObject.values)),
    ),
  };
};

export default transform;
